import state from "./moduleMarketState";
import mutations from "./moduleMarketMutations";
import actions from "./moduleMarketActions";
import getters from "./moduleMarketGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
